import { trackEvent } from "src/utils/api/tracker";
import { ActionHandlerParams } from "..";
import { getPageSetSurvey } from "./util";
import {
  saveSurveyAnswers,
  setUserProperties,
} from "src/utils/redux/slices/userData";
import { getInternalSurveyNamespace } from "src/utils/survey/surveyNamespace";
import { isQualifiedForPersonalizedDosing } from "src/utils/userSegment/features";
import { getMedState } from "src/utils/medEligibility";

export const onCompletePDQuestions = async ({
  store,
  pageSet,
  page,
}: ActionHandlerParams) => {
  trackEvent("PDEligibilityDetermined", {
    isEligible: isQualifiedForPersonalizedDosing(getMedState()),
  });

  const survey = getPageSetSurvey(pageSet, page);

  const { surveyNameSpace } = survey;
  const { currentAnswers } = store.getState();

  const internalNamespaceName = getInternalSurveyNamespace(surveyNameSpace);
  const surveyAnswers = currentAnswers.questionAnswers[surveyNameSpace];

  await store.dispatch(
    saveSurveyAnswers(surveyAnswers, {
      surveyNameSpace: internalNamespaceName,
      overwrite: false,
    })
  );

  await store.dispatch(
    setUserProperties({
      completedPDQuestions: true,
    })
  );
};
